module.exports = __webpack_public_path__ + "img/premium-1.9ad64557.jpg";